import { render, staticRenderFns } from "./PasswordSnackbar.vue?vue&type=template&id=35b7319c"
import script from "./PasswordSnackbar.vue?vue&type=script&lang=ts"
export * from "./PasswordSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports